export const navigations: NavigationModel[] = [
    {
        id: 'mail-box',
        title: 'Mail-Box',
        translate: 'MAILBOX',
        type: 'item',
        url: '/mailbox',
        iconType: 'material',
        icon: 'email',
        isVisible: true
    },
    {
        id: 'up-ipex-cases',
        title: 'Case Center',
        translate: 'UPLOAD_IPEX_CASES',
        type: 'item',
        url: 'case-center',
        iconType: 'svg',
        icon: 'assets/images/iws-icon_2.svg',
        isVisible: true
    },
    {
        id: 'jarowa-integrator',
        title: 'JAROWA',
        translate: 'JAROWA',
        type: 'item',
        url: '/jarowa',
        iconType: 'svg',
        icon: 'assets/images/yarowa.svg',

        isVisible: true
    },
    {
        id: 'yarowa-integrator',
        title: 'YAROWA',
        translate: 'YAROWA',
        type: 'item',
        url: '/master-data/yarowa-cockpit',
        iconType: 'svg',
        icon: 'assets/images/yarowa.svg',
        isVisible: true
    },
    {
        id: 'cases',
        title: 'CASES',
        translate: 'CASES',
        type: 'item',
        url: '/cases',
        iconType: 'material',
        icon: 'assignment',
        isVisible: true
    },
    {
        id: 'quality-check-list',
        title: 'Quality Check',
        translate: 'QUALITY_CHECK',
        type: 'item',
        url: '/quality-check',
        iconType: 'material',
        icon: 'check_circle',
        isVisible: true
    },
    {
        id: 'master-data',
        title: 'Master Data',
        translate: 'ADMIN_CONTROLS',
        type: 'item',
        url: '/master-data',
        iconType: 'material',
        icon: 'admin_panel_settings',
        isVisible: true
    },

    {
        id: 'PCX.Navigation',
        title: 'Users',
        translate: 'USERS',
        type: 'item',
        url: '/users',
        iconType: 'material',
        icon: 'supervised_user_circle',
        isVisible: false
    },
    {
        id: 'dashboard',
        title: 'Dashboard',
        translate: 'DASHBOARD',
        type: 'item',
        url: '/dashboard',
        iconType: 'material',
        icon: 'dashboard',
        isVisible: true
    }
];

export class NavigationModel {
    id: string;
    title: string;
    translate: string;
    type: string;
    url: string;
    iconType: string;
    icon: string;
    isVisible: boolean;
    badge?: any;
}
